import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, Button } from 'react-bootstrap';
import './Style.scss';
import { withRouter, Link } from 'react-router-dom'
const View = (props) => {

    function scrollToSection(id) {
        if (window.location.pathname !== '/patient') {
            props.history.push({
                pathname: '/patient',
                state: {}
            });
            return;
        }
        var elmnt = document.getElementById(id);
        if (elmnt) {
            elmnt.scrollIntoView({
                behavior: "smooth"
            });
        }
    }

    function gotoCheckStatusPage() {
        props.history.push({
            pathname: '/referdetail',
            state: {}
        });
    }

    return (
        <Navbar sticky="top" className="navigationBar" expand="lg">
            <Navbar.Brand href="/patient">
                <img
                    alt={"Zivov Logo"}
                    src={require('@Images/logo.png')}
                    className="logo" />
                <span className="logoText">Zivov</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Nav>
                    <Nav.Link as={Link} className={`navlinkWeb ${props.pageHeaderTitle === 'mainPage' ? 'navlinkWebActive' : ''}`} onClick={() => { scrollToSection('patinetSection') }}>For Patients</Nav.Link>
                    <Nav.Link as={Link} className="navlinkWeb" onClick={() => { scrollToSection('doctorSection') }}>For Doctors</Nav.Link>
                    <Nav.Link as={Link} to="/blog" className={`navlinkWeb ${props.pageHeaderTitle === 'blogPage' ? 'navlinkWebActive' : ''}`}>Blog</Nav.Link>
                    <Nav.Link target="_blank" className="navlinkWeb" href={process.env.REACT_APP_COMMUNITY}>Community</Nav.Link>
                    <Button className={`activationCodeBt ${props.pageHeaderTitle === 'referDetailPage' ? '' : ''}`}  onClick={() => { gotoCheckStatusPage() }}>My Status</Button>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};


View.propTypes = {
    pageHeaderTitle: PropTypes.string.isRequired
};

export default withRouter(View);

